const getBackgroundColor = (colorsObj, color, fabric = null, category = "other") => {
    fabric = fabric?.toLowerCase();
    color = color?.toLowerCase();

    if (fabric) {
        const fabricColor = colorsObj[color]?.fabricColors?.find(
            (variant) => variant?.fabricName?.toLowerCase() === fabric && variant?.categoryType?.toLowerCase() === category,
        );
        if (fabricColor) {
            return fabricColor.color?.hex;
        }
    }
    return colorsObj[color]?.color?.hex || color || undefined;
};
export default getBackgroundColor;
